import api from 'api'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    regeneratePaymentReceipts: build.mutation({
      query: body => ({ url: '/api/v1/billing/payment/regenerate_receipt', method: 'POST', body }),
    }),
  }),
})

export const { useRegeneratePaymentReceiptsMutation } = extendedApi
